import { useEffect, useState } from 'react';

import {
  GET_ALL_CONTRACT_NAMES,
  SWING_CONTRACT_MESSAGES,
} from '../../../constants/FieldNomsSwingContract';
import { HTTPS_STATUS_CODES } from '../../../constants/Common';
import { get } from '../../../services/GenesisApi';
import { sendNotification } from '../../../UI/Notification';

interface ContractName {
  id: string;
  name: string;
}

const { FAILED_FETCH_CONTRACT_NAMES } = SWING_CONTRACT_MESSAGES;

const useGetAllContractNames = () => {
  const [contractNames, setContractNames] = useState<ContractName[]>([]);
  const [loading, setLoading] = useState<boolean>(false);
  const [error, setError] = useState<string | null>(null);

  const getAllContractNames = (): Promise<ContractName[]> => {
    setLoading(true);
    setError(null);

    return get(GET_ALL_CONTRACT_NAMES)
      .then((res) => {
        if (res.status === HTTPS_STATUS_CODES.SUCCESS) {
          const { data } = res;
          setContractNames(data);
          return data;
        }

        throw new Error(res.statusText ?? FAILED_FETCH_CONTRACT_NAMES);
      })
      .catch((err) => {
        setError(err ?? FAILED_FETCH_CONTRACT_NAMES);
        sendNotification({
          type: 'error',
          message: err ?? FAILED_FETCH_CONTRACT_NAMES,
        });
        return [];
      })
      .finally(() => {
        setLoading(false);
      });
  };
  useEffect(() => {
    getAllContractNames();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return { contractNames, loading, error, getAllContractNames };
};

export default useGetAllContractNames;
